import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c0884d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Variant:", -1))
const _hoisted_2 = {
  class: "custom-text-mini",
  hidden: ""
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Option1:", -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Option2:", -1))
const _hoisted_7 = { key: 2 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Option3:", -1))
const _hoisted_9 = { class: "flex items-center justify-start" }
const _hoisted_10 = { class: "text-success" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Choose")
const _hoisted_12 = {
  key: 0,
  style: {"width":"100%"},
  class: "text-center"
}
const _hoisted_13 = { class: "dialog-footer" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode("  Close ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ChooseCatalogCodePreview = _resolveComponent("ChooseCatalogCodePreview")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.showModalVisible,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showModalVisible) = $event)),
    title: "Chooose Catalog Code Product",
    top: "3vh",
    width: "65%"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_13, [
        _createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.close())),
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_14,
            _hoisted_15
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { class: "w-full mb-5" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, [
                    _hoisted_1,
                    _createTextVNode(" " + _toDisplayString(_ctx.productVariant.title), 1)
                  ]),
                  _createElementVNode("span", _hoisted_2, [
                    (_ctx.productVariant.option1)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                          _hoisted_4,
                          _createTextVNode(" " + _toDisplayString(_ctx.productVariant.option1), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.productVariant.option2)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                          _hoisted_6,
                          _createTextVNode(" " + _toDisplayString(_ctx.productVariant.option2), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.productVariant.option3)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                          _hoisted_8,
                          _createTextVNode(" " + _toDisplayString(_ctx.productVariant.option3), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { class: "w-full" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    class: "mx-1",
                    modelValue: _ctx.state.form.type,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.form.type) = $event)),
                    placeholder: "Catalog Type",
                    onChange: _ctx.onSelectCatalogType,
                    filterable: "",
                    clearable: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catalogTypes, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.title,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"]),
                  _createVNode(_component_el_select, {
                    class: "mx-1",
                    modelValue: _ctx.state.form.catalog,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.form.catalog) = $event)),
                    placeholder: "Select Catalog",
                    onChange: _ctx.onSelectCatalog,
                    filterable: "",
                    clearable: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.catalogs, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item._id,
                          label: item.name,
                          value: item._id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { class: "w-full my-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_ChooseCatalogCodePreview, {
                images: _ctx.state.selectedCatalog?.mockupGallery || []
              }, null, 8, ["images"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { class: "w-full" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 24,
                class: "mt-5 text-right font-bold"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" (" + _toDisplayString(_ctx.variants?.length || 0) + " variants) ", 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_el_table, {
                    data: _ctx.variants,
                    "element-loading-text": "Loading...",
                    lazy: "",
                    style: {"width":"100%"},
                    stripe: "",
                    "table-layout": "auto",
                    "max-height": "500px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        "min-width": 10,
                        label: "Variant code"
                      }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(scope.row?.catalogVariantCode), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "color",
                        label: "Color",
                        "min-width": "15"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", _hoisted_9, [
                            (scope.row.color.value)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "w-4 h-4 bg-color-variant mr-1",
                                  style: _normalizeStyle(`--color:${scope.row.color.value}`)
                                }, null, 4))
                              : (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: "w-4 h-4 bg-color-variant mr-1",
                                  style: _normalizeStyle(`--color:${scope.row.color.name}`)
                                }, null, 4)),
                            _createElementVNode("div", null, _toDisplayString(scope.row.color.name), 1)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "size",
                        label: "Size",
                        "min-width": "10"
                      }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(scope.row.size.name), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Design Qty",
                        "min-width": "10"
                      }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(_ctx.detectDesignQty(_ctx.state.selectedCatalog, scope.row)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Design",
                        "min-width": "10"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detectDesignName(
                      _ctx.state.selectedCatalog,
                      scope.row
                    ), (item) => {
                              return (_openBlock(), _createElementBlock("p", { key: item }, _toDisplayString(item), 1))
                            }), 128))
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "suggest",
                        label: "Suggest",
                        "min-width": "10"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("span", _hoisted_10, _toDisplayString(scope.row.suggest ? 'Suggest size' : ''), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Actions",
                        "min-width": "10"
                      }, {
                        default: _withCtx((scope) => [
                          _createVNode(_component_el_popconfirm, {
                            "confirm-button-text": "Confirm",
                            "cancel-button-text": "Cancel",
                            "icon-color": "#626AEF",
                            title: "Order will update FFM code. Confirm change?",
                            onConfirm: ($event: any) => (_ctx.onChooseVariantCode(scope.row)),
                            width: "20%"
                          }, {
                            reference: _withCtx(() => [
                              _createVNode(_component_el_button, { size: "small" }, {
                                default: _withCtx(() => [
                                  _hoisted_11
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["onConfirm"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"]), [
                    [_directive_loading, _ctx.isLoading]
                  ]),
                  (_ctx.variants?.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "text",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onClickShowMore()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.isShowAllVariant ? 'Hide' : 'Load more'), 1)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}